module.exports = "/dist/assets/images/listview.svg";